/* eslint-disable no-control-regex */
export function changeOrder(currentOrder) {
  if (currentOrder === 0 || currentOrder === -1) {
    currentOrder += 1;
  } else if (currentOrder === 1) {
    currentOrder *= -1;
  } else {
    currentOrder = 0;
  }
  return currentOrder;
}

export function getSortParams(orderList) {
  let sort = [];
  for (const [k, v] of Object.entries(orderList)) {
    if (v !== 0) {
      let itemOrder = v === 1 ? k : "-" + k;
      sort.push(itemOrder);
    }
  }
  sort = sort.join(",");
  return sort;
}

export function isNonAscii(str) {
  return /[^\x00-\x7F]+/.test(str);
}

export function smoothScrollToTop() {
  const scrollToTop = () => {
    const currentPosition = window.pageYOffset;
    if (currentPosition > 0.5) {
      window.scrollTo(0, currentPosition - currentPosition / 8);
      requestAnimationFrame(scrollToTop);
    }
  };
  requestAnimationFrame(scrollToTop);
}

export function convertBytesToMB(byte) {
  return byte / (1024 * 1024);
}

export function isButtonProcessing(buttonProcessing, buttonProps) {
  if (
    buttonProps.id &&
    buttonProcessing.isProcessingButton &&
    buttonProcessing.buttonProcessing.includes(buttonProps.id)
  ) {
    return true;
  }
  return false;
}

export function getButtonProcessingClass(isProcessing) {
  if (isProcessing) {
    return "pointer-events-none";
  }
  return "";
}

export function handleOnBeforeUnload(event) {
  event.preventDefault();
  return (event.returnValue = "");
}

export const renderPdfToImage = async (pdf, fileName) => {
  const page = await pdf.getPage(1);

  const scale = 1.5;
  const viewport = page.getViewport({scale});

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.height = viewport.height;
  canvas.width = viewport.width;

  const renderContext = {
    canvasContext: context,
    viewport: viewport
  };

  await page.render(renderContext).promise;
  const imageBlob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
  const filePdfImageName = fileName + '.png';

  return new File([imageBlob], filePdfImageName, {type: 'image/png'});
};

export const createThumbnail = (file, callback) => {
  const img = new Image();
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const TARGET_SIZE = 165;

  const reader = new FileReader();
  reader.onload = (event) => {
    img.src = event.target.result;

    img.onload = () => {
      const scale = Math.max(TARGET_SIZE/ img.width, TARGET_SIZE/ img.height);

      const scaledWidth = img.width * scale;
      const scaledHeight = img.height * scale;

      const cropX = (scaledWidth - TARGET_SIZE) / 2;
      const cropY = (scaledHeight - TARGET_SIZE) / 2;
      canvas.width = TARGET_SIZE;
      canvas.height = TARGET_SIZE;
      ctx.drawImage(img, -cropX, -cropY, scaledWidth, scaledHeight);

      canvas.toBlob(
        (blob) => {
          if (blob)  {
            const thumbnailFile = new File(
              [blob],
                  `${file.name.replace(/\.[^/.]+$/, "")}_thumb${file.name.slice(
                    file.name.lastIndexOf(".")
                  )}`,
              {type: file.type}
            );
            callback(thumbnailFile)
          }
        },
        file.type,
        0.9
      )
    }
  };
  reader.readAsDataURL(file)
};